import { Link } from "react-router-dom";

type Props = {
  link: string;
  text: string;
};

const MenuLinkBtn = ({ link, text }: Props) => {
  return (
    <Link to={link} className="admin__menu__item">
      {text}
    </Link>
  );
};

export default MenuLinkBtn;
